import { render, staticRenderFns } from "./PickColor.vue?vue&type=template&id=3f8c2d88&"
import script from "./PickColor.vue?vue&type=script&lang=js&"
export * from "./PickColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports